import React from 'react';
import { Card, Typography } from 'antd';

const { Title } = Typography;

const Billing = () => {
  return (
    <div>
      <Title level={2}>Cobrança</Title>
      <Card>
        <p>Gerenciamento de cobrança para organizadores.</p>
      </Card>
    </div>
  );
};

export default Billing;